import {    
    SET_USER_COUNTRY,    
    SET_COUNTRIES,    
    LOADING_DATA,    
    STOP_LOADING,    
    SET_TAB_INDEX    
} from '../types';    

const initialState = {    
    userCountry: '',    
    countries: [],    
    tabIndex: 0,    
    loading: false,    
}    

export default function(state = initialState, action){    
    switch(action.type){    
        case SET_USER_COUNTRY:    
            return {    
                ...state,    
                userCountry: action.payload    
            }    
        case SET_COUNTRIES:    
            return {    
                ...state,    
                countries: action.payload,    
                loading: false    

            }    
        case LOADING_DATA:    
            return {    
                ...state,    
                loading: true    
            }    
        case STOP_LOADING:    
             return {    
                ...state,    
                loading: false    
             }    
        case SET_TAB_INDEX:    
             return {    
                ...state,    
                tabIndex: action.payload    
             }    

                default:    
                return state;    
    }    
} 